import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-se-listing-search',
  templateUrl: './se-listing-search.component.html',
  styleUrls: ['./se-listing-search.component.scss'],
})
export class SeListingSearchComponent implements OnInit {
  @Input() value1 = '';
  @Input() value2 = '';
  @Output() searchingText = new EventEmitter<InputEvent>();
  @Output() openFilter = new EventEmitter<null>();
  @Output() updateFilter = new EventEmitter<{ id: string; value: string }>();
  constructor() {}

  ngOnInit(): void {}

  searchText(event: InputEvent): any {
    this.searchingText.emit(event);
  }

  _openFilter(): any {
    this.openFilter.emit();
  }

  _updateFilter(id: string, value: string): any {
    this.updateFilter.emit({ id, value });
  }
}
